// extracted by mini-css-extract-plugin
export default {"pollDisplay":"PollDisplaySection_pollDisplay__LWmKx"};